(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cedre-campaign-popup"] && !Shopify.designMode) return;
  try {
    
    if (!customElements.get('cedre-campaign-popup')) {
      customElements.define(
        'cedre-campaign-popup',
        class CedreCampaignPopup extends HTMLElement {
          constructor() {
            super();
            this.dialog = this.querySelector('[data-campaign-popup-dialog]');
            this.overlay = this.querySelector('[data-campaign-popup-overlay]');
            this.closeButtons = [...this.querySelectorAll('[data-campaign-popup-close]')];
            this.banners = [...this.querySelectorAll('[data-campaign-popup-banner]')];
            this.bannerLinks = [...this.querySelectorAll('[data-campaign-popup-link]')];
            this.activeBanner = null;
            this.storagePrefix = 'cedreCampaignPopupClosedAt:';
            this.onCloseClick = this.close.bind(this);
            this.onOverlayClick = this.close.bind(this);
            this.onBannerLinkClick = this.handleBannerLinkClick.bind(this);
            this.onKeydown = this.handleKeydown.bind(this);
          }

          connectedCallback() {
            this.closeButtons.forEach((button) => button.addEventListener('click', this.onCloseClick));
            this.bannerLinks.forEach((link) => link.addEventListener('click', this.onBannerLinkClick));
            if (this.overlay) this.overlay.addEventListener('click', this.onOverlayClick);

            window.requestAnimationFrame(() => {
              this.openFirstEligibleBanner();
            });
          }

          disconnectedCallback() {
            this.closeButtons.forEach((button) => button.removeEventListener('click', this.onCloseClick));
            this.bannerLinks.forEach((link) => link.removeEventListener('click', this.onBannerLinkClick));
            if (this.overlay) this.overlay.removeEventListener('click', this.onOverlayClick);
            document.removeEventListener('keydown', this.onKeydown);
            document.body.classList.remove('cedre-campaign-popup-open');
          }

          openFirstEligibleBanner() {
            const banner = this.banners.find((candidate) => this.isEligible(candidate));
            if (!banner) return;

            this.activeBanner = banner;
            banner.hidden = false;
            this.classList.add('is-open');
            document.body.classList.add('cedre-campaign-popup-open');
            document.addEventListener('keydown', this.onKeydown);

            if (typeof window.pauseAllMedia === 'function') {
              window.pauseAllMedia();
            }

            if (typeof trapFocus === 'function' && this.dialog) {
              const focusTarget = this.querySelector('[data-campaign-popup-close]') || this.dialog;
              trapFocus(this.dialog, focusTarget);
            } else if (this.dialog) {
              this.dialog.focus();
            }
          }

          isEligible(banner) {
            const bannerId = banner.dataset.bannerId;
            if (!bannerId) return false;

            const now = Date.now();
            const startAt = this.parseJapanDateTime(
              banner.dataset.startDate || '',
              banner.dataset.startTime || '',
              bannerId,
              '表示開始'
            );
            const endAt = this.parseJapanDateTime(
              banner.dataset.endDate || '',
              banner.dataset.endTime || '',
              bannerId,
              '表示終了'
            );

            if (!Number.isFinite(startAt) || !Number.isFinite(endAt)) return false;
            if (startAt > endAt) {
              console.warn(`[CÈDRE Campaign Popup] ${bannerId}: 表示開始日時が表示終了日時より後です。`);
              return false;
            }
            if (now < startAt || now > endAt) return false;
            if (this.isSuppressed(bannerId, now)) return false;

            return true;
          }

          parseJapanDateTime(dateValue, timeValue, bannerId, fieldName) {
            const dateMatch = dateValue.trim().match(/^(\d{4})-(\d{2})-(\d{2})$/);
            const timeMatch = timeValue.trim().match(/^(\d{2}):(\d{2}):(\d{2})$/);

            if (!dateMatch) {
              console.warn(
                `[CÈDRE Campaign Popup] ${bannerId}: ${fieldName}日は YYYY-MM-DD 形式で入力してください。`
              );
              return Number.NaN;
            }

            if (!timeMatch) {
              console.warn(
                `[CÈDRE Campaign Popup] ${bannerId}: ${fieldName}時間は HH:mm:ss 形式で入力してください。`
              );
              return Number.NaN;
            }

            const [, yearText, monthText, dayText] = dateMatch;
            const [, hourText, minuteText, secondText] = timeMatch;
            const year = Number(yearText);
            const month = Number(monthText);
            const day = Number(dayText);
            const hour = Number(hourText);
            const minute = Number(minuteText);
            const second = Number(secondText);

            if (month < 1 || month > 12 || hour > 23 || minute > 59 || second > 59) {
              console.warn(`[CÈDRE Campaign Popup] ${bannerId}: ${fieldName}日時が不正です。`);
              return Number.NaN;
            }

            const timestamp = Date.UTC(year, month - 1, day, hour - 9, minute, second);
            const japanDate = new Date(timestamp + 9 * 60 * 60 * 1000);

            if (
              japanDate.getUTCFullYear() !== year ||
              japanDate.getUTCMonth() !== month - 1 ||
              japanDate.getUTCDate() !== day ||
              japanDate.getUTCHours() !== hour ||
              japanDate.getUTCMinutes() !== minute ||
              japanDate.getUTCSeconds() !== second
            ) {
              console.warn(`[CÈDRE Campaign Popup] ${bannerId}: ${fieldName}日が存在しません。`);
              return Number.NaN;
            }

            return timestamp;
          }

          isSuppressed(bannerId, now) {
            const suppressionDays = Number(this.dataset.suppressionDays || 1);
            if (!Number.isFinite(suppressionDays) || suppressionDays <= 0) return false;

            try {
              const closedAt = Number(window.localStorage.getItem(this.storagePrefix + bannerId));
              if (!Number.isFinite(closedAt)) return false;
              return now - closedAt < suppressionDays * 24 * 60 * 60 * 1000;
            } catch (error) {
              return false;
            }
          }

          close() {
            if (!this.activeBanner) return;

            this.suppressBanner(this.activeBanner);

            this.activeBanner.hidden = true;
            this.activeBanner = null;
            this.classList.remove('is-open');
            document.body.classList.remove('cedre-campaign-popup-open');
            document.removeEventListener('keydown', this.onKeydown);

            if (typeof removeTrapFocus === 'function') {
              removeTrapFocus();
            }
          }

          handleBannerLinkClick() {
            if (!this.activeBanner) return;
            this.suppressBanner(this.activeBanner);
          }

          suppressBanner(banner) {
            if (!banner || !banner.dataset.bannerId) return;

            try {
              window.localStorage.setItem(this.storagePrefix + banner.dataset.bannerId, String(Date.now()));
            } catch (error) {
              // localStorageが使えない環境では、その場で閉じる挙動だけ維持する。
            }
          }

          handleKeydown(event) {
            if (event.code === 'Escape') {
              this.close();
            }
          }
        }
      );
    }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cedre-top-banner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cedre-top-banner')) {
    customElements.define(
      'cedre-top-banner',
      class CedreTopBanner extends HTMLElement {
        constructor() {
          super();
          this.items = [...this.querySelectorAll('[data-top-banner-item]')];
        }

        connectedCallback() {
          this.updateVisibleItems();
        }

        updateVisibleItems() {
          let visibleCount = 0;

          this.items.forEach((item) => {
            const isVisible = this.isEligible(item);
            item.hidden = !isVisible;
            if (isVisible) visibleCount += 1;
          });

          if (visibleCount === 0) {
            this.hidden = true;
          }
        }

        isEligible(item) {
          const bannerId = item.dataset.bannerId || 'top-banner';
          const now = Date.now();
          const startAt = this.parseJapanDateTime(
            item.dataset.startDate || '',
            item.dataset.startTime || '',
            bannerId,
            '表示開始'
          );
          const endAt = this.parseJapanDateTime(
            item.dataset.endDate || '',
            item.dataset.endTime || '',
            bannerId,
            '表示終了'
          );

          if (!Number.isFinite(startAt) || !Number.isFinite(endAt)) return false;
          if (startAt > endAt) {
            console.warn(`[CÈDRE TOP Banner] ${bannerId}: 表示開始日時が表示終了日時より後です。`);
            return false;
          }

          return now >= startAt && now <= endAt;
        }

        parseJapanDateTime(dateValue, timeValue, bannerId, fieldName) {
          const dateMatch = dateValue.trim().match(/^(\d{4})-(\d{2})-(\d{2})$/);
          const timeMatch = timeValue.trim().match(/^(\d{2}):(\d{2}):(\d{2})$/);

          if (!dateMatch) {
            console.warn(`[CÈDRE TOP Banner] ${bannerId}: ${fieldName}日は YYYY-MM-DD 形式で入力してください。`);
            return Number.NaN;
          }

          if (!timeMatch) {
            console.warn(`[CÈDRE TOP Banner] ${bannerId}: ${fieldName}時間は HH:mm:ss 形式で入力してください。`);
            return Number.NaN;
          }

          const [, yearText, monthText, dayText] = dateMatch;
          const [, hourText, minuteText, secondText] = timeMatch;
          const year = Number(yearText);
          const month = Number(monthText);
          const day = Number(dayText);
          const hour = Number(hourText);
          const minute = Number(minuteText);
          const second = Number(secondText);

          if (month < 1 || month > 12 || hour > 23 || minute > 59 || second > 59) {
            console.warn(`[CÈDRE TOP Banner] ${bannerId}: ${fieldName}日時が不正です。`);
            return Number.NaN;
          }

          const timestamp = Date.UTC(year, month - 1, day, hour - 9, minute, second);
          const japanDate = new Date(timestamp + 9 * 60 * 60 * 1000);

          if (
            japanDate.getUTCFullYear() !== year ||
            japanDate.getUTCMonth() !== month - 1 ||
            japanDate.getUTCDate() !== day ||
            japanDate.getUTCHours() !== hour ||
            japanDate.getUTCMinutes() !== minute ||
            japanDate.getUTCSeconds() !== second
          ) {
            console.warn(`[CÈDRE TOP Banner] ${bannerId}: ${fieldName}日が存在しません。`);
            return Number.NaN;
          }

          return timestamp;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mainContent = document.getElementById('MainContent');
      this.enableTransparent = this.getAttribute('data-enable-transparent') === 'true';
      this.heroSection = null;
      this.heroOverlayEnabled = false;
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
      this.onResizeHandler = this.onResize.bind(this);
      this.onMenuDrawerToggleHandler = this.onMenuDrawerToggle.bind(this);
      this.menuDrawerDetails = this.querySelector('#Details-menu-drawer-container');

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      window.addEventListener('resize', this.onResizeHandler);
      if (this.menuDrawerDetails) {
        this.menuDrawerDetails.addEventListener('toggle', this.onMenuDrawerToggleHandler);
      }

      this.createObserver();
      this.setupHeroOverlay();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
      this.updateHeroOverlayState();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('resize', this.onResizeHandler);
      if (this.menuDrawerDetails) {
        this.menuDrawerDetails.removeEventListener('toggle', this.onMenuDrawerToggleHandler);
      }
      document.body.classList.remove('header-over-hero');
      this.classList.remove('header-wrapper--transparent');
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      this.updateHeroOverlayState();

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    onResize() {
      this.setHeaderHeight();
      this.createObserver();
      this.setupHeroOverlay();
    }

    onMenuDrawerToggle() {
      if (!this.menuDrawerDetails || this.menuDrawerDetails.open) return;

      this.classList.add('header-wrapper--no-transition');
      this.updateHeroOverlayState();

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          this.classList.remove('header-wrapper--no-transition');
        });
      });
    }

    setupHeroOverlay() {
      if (!this.enableTransparent) {
        this.disableHeroOverlay();
        return;
      }

      const firstSection = this.mainContent?.querySelector(':scope > .shopify-section:first-child');

      if (!firstSection) {
        this.disableHeroOverlay();
        return;
      }

      const heroTarget = firstSection.querySelector('.slideshow, .banner, .cedre-hero, .video-section, .collection-hero');

      if (!heroTarget) {
        this.disableHeroOverlay();
        return;
      }

      this.heroOverlayEnabled = true;
      this.heroSection = firstSection;
      document.body.classList.add('header-over-hero');
      this.updateHeroOverlayState();
    }

    disableHeroOverlay() {
      this.heroOverlayEnabled = false;
      this.heroSection = null;
      document.body.classList.remove('header-over-hero');
      this.classList.remove('header-wrapper--transparent');
    }

    updateHeroOverlayState() {
      if (!this.heroOverlayEnabled || !this.heroSection) {
        this.classList.remove('header-wrapper--transparent');
        return;
      }

      const heroBottom = this.heroSection.getBoundingClientRect().bottom;
      const shouldTransparent = heroBottom > this.header.offsetHeight;
      this.classList.toggle('header-wrapper--transparent', shouldTransparent);
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
